import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText } from '@prismicio/react';
import { ImageField, RichTextField } from '@prismicio/types';
import { FC } from 'react';
import StarfieldBackgroundClient from '@/components/client-wrappers/StarfieldBackgroundClient';

interface WithLogoOnTopProps {
  slice: {
    slice_type: string;
    variation: string;
  };
  title: RichTextField;
  image: ImageField<never>;
}

const WithLogoOnTop: FC<WithLogoOnTopProps> = ({ slice, title, image }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="relative text-white pt-32 pb-24 md:pt-48 md:pb-40 overflow-hidden"
    >
      {/* Background gradient visible while animation loads */}
      <div
        className="absolute inset-0 w-full h-full"
        style={{
          background: 'linear-gradient(180deg, #0E1010 0%, #0F423A 100%)',
          zIndex: -2,
        }}
      />
      <StarfieldBackgroundClient />
      <div className="relative z-10 container mx-auto px-10 py-20 flex flex-col items-center text-center">
        <PrismicNextImage
          field={image}
          className="w-[160px] object-contain mb-6"
          alt=""
        />
        <PrismicRichText
          field={title}
          components={{
            heading1: ({ children }) => (
              <h1 className="text-white font-inter font-extrabold text-[56px] leading-[120%]">
                {children}
              </h1>
            ),
            heading2: ({ children }) => (
              <h2 className="text-white font-inter font-extrabold text-[56px] leading-[120%]">
                {children}
              </h2>
            ),
          }}
        />
      </div>
    </section>
  );
};

export default WithLogoOnTop;
